import React, { useState } from "react";
import { Row, Col, Card, Space, Typography, Form, Button, Layout, Divider, message, Input, Modal } from "antd";
import { ArrowLeftOutlined, LockOutlined, EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { IMAGES } from "../../constants/images";
import { deleteCurriculo } from "../../api/curriculoUsuario";
import { useAuth } from "../../contexts/AuthContext";
import { configModal } from "../../components/modalConfig/config";

const { Title, Text } = Typography;

const styles = {
  row: {
    flexGrow: 1,
    padding: "1%",
  },
};

const validator = {
  senha: [{ required: true, message: "Informe a sua senha!" }],
};

const ExcluirConta = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const { encerrarSessao } = useAuth();
  const [form] = Form.useForm();

  const deletar = async (formulario) => {
    setLoading(true);
    try {
      const retorno = await deleteCurriculo(formulario);
      if (retorno?.statusCode === 200) {
        await encerrarSessao();
        navigate("/login");
        message.success("Conta excluída com sucesso!");
      } else {
        message.error(retorno?.response?.message);
      }
    } catch (error) {
      message?.error("Não foi possível atender a requisição!");
    }
    setLoading(false);
  };

  const onSubmit = (formulario) => {
    deletar(formulario);
  };

  return (
    <Row justify="center" align="middle" className="full-width" style={styles?.row}>
      <Col xs={23} sm={18} md={14} lg={12} xl={8} xxl={6}>
        <Card>
          <Space direction="vertical" className="full-width" size={20}>
            <Layout.Content align="center">
              <img width={140} src={IMAGES?.deletarConta} className="resize-contain" />
            </Layout.Content>

            <Title className="title" align="center">
              Excluir Conta
            </Title>

            <Text align="justify">
              Exluindo sua conta, os dados pessoais do seu cadastro serão apagados dos nossos bancos de dados.
              <br />
              Após a exclusão, será necessário realizar um novo cadastro para participar de seleções futuras.
            </Text>

            <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
              <Form.Item className="FormItem" label="Senha" name="senha" rules={validator?.senha} hasFeedback>
                <Input.Password
                  size="large"
                  className="input"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="Digite a sua senha"
                  iconRender={(visible) =>
                    visible ? <EyeOutlined /> : <EyeInvisibleOutlined style={{ color: "#000" }} />
                  }
                  disabled={loading}
                />
              </Form.Item>

              <Form.Item className="FormItem">
                <Button
                  danger
                  size="large"
                  loading={loading}
                  type="primary"
                  onClick={() =>
                    modal.confirm({
                      ...configModal,
                      title: "Deseja realmente excluir sua conta?",
                      okButtonProps: { danger: true },
                      onOk() {
                        form.submit();
                      },
                    })
                  }
                  style={{ width: "100%" }}
                  className="login-form-button">
                  Deletar Conta
                </Button>
              </Form.Item>
            </Form>
          </Space>
          <Divider />
          <Form.Item className="FormItem">
            <Button icon={<ArrowLeftOutlined />} size="large" onClick={() => navigate("/")} loading={loading}>
              Voltar
            </Button>
          </Form.Item>
        </Card>
      </Col>
      {contextHolder}
    </Row>
  );
};

export default ExcluirConta;
